import { ArrowLink } from "@/components/ArrowLink";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <section className="grid min-h-[80vh] place-items-center px-5 pt-32 text-center" data-testid="not-found-page">
      <Seo title="Page not found" path="/" description="This page could not be found at Little Englishman's Bay Estate." />
      <div>
        <p className="font-display text-8xl text-gold">404</p>
        <h1 className="mt-4 font-display text-4xl text-heritage">This path leads nowhere on the estate.</h1>
        <div className="mt-10 flex justify-center"><ArrowLink to="/" testid="not-found-home-link">Return home</ArrowLink></div>
      </div>
    </section>
  );
}
